import { useDispatch } from "react-redux";

import { mutateNodeDesignsSelector } from "../mutatingSelectors/index.ts";
import { useNautilusSelector } from "../shared.ts";

export const useMutateNodeDesigns = () => {
  const dispatch = useDispatch();
  return useNautilusSelector((state) => mutateNodeDesignsSelector(state, { dispatch }));
};
